module.exports = __webpack_public_path__ + "static/media/country_nr.f54f794e.webp";